module.exports = __webpack_public_path__ + "img/space-shooter.9ed731d7.png";